var _g, _rect, _g2, _rect2, _rect3, _rect4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMystic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 60,
    viewBox: "0 0 43 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_754_4086)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.89,
    height: 59.57,
    rx: 2.49254,
    fill: "url(#paint0_linear_754_4086)"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_754_4086)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.95691,
    y: 5.95752,
    width: 30.9761,
    height: 46.4646,
    rx: 0.997015,
    fill: "url(#paint1_linear_754_4086)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_754_4086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8247 37.2601H12.8997C12.3997 37.2601 12.1497 37.0101 12.1497 36.5101V20.3601C12.1497 19.8601 12.3997 19.6101 12.8997 19.6101H16.4747C16.8997 19.6101 17.1997 19.7851 17.3747 20.1101L22.7747 29.1851L28.1497 20.1101C28.3247 19.7851 28.6247 19.6101 29.0497 19.6101H32.6247C33.1247 19.6101 33.3747 19.8601 33.3747 20.3601V36.5101C33.3747 37.0101 33.1247 37.2601 32.6247 37.2601H29.6997C29.1997 37.2601 28.9497 37.0101 28.9497 36.5101V26.6351L24.5247 33.9601C24.3497 34.2851 24.0497 34.4601 23.6247 34.4601H21.8747C21.4497 34.4601 21.1497 34.2851 20.9747 33.9601L16.5747 26.7101V36.5101C16.5747 37.0101 16.3247 37.2601 15.8247 37.2601Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.2
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11.7315,
    height: 50.0452,
    transform: "matrix(0.629618 0.776905 -0.792169 0.610302 36.0702 3.63464)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.2
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.6926,
    height: 47.2013,
    transform: "matrix(0.629618 0.776905 -0.792169 0.610302 40.8145 18.3774)",
    fill: "white"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.20616,
    y: 6.20677,
    width: 30.4776,
    height: 45.9661,
    rx: 0.747761,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.498508
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_754_4086",
    x: 0,
    y: -0.498508,
    width: 42.89,
    height: 60.567,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.997015,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_754_4086"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.498508
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "hard-light",
    in2: "shape",
    result: "effect1_innerShadow_754_4086"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.997015,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_innerShadow_754_4086"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.498508
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_754_4086",
    result: "effect2_innerShadow_754_4086"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_754_4086",
    x: 12.1497,
    y: 19.6101,
    width: 21.2251,
    height: 18.0685,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.41844
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.20922
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_754_4086"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_754_4086",
    x1: 21.445,
    y1: 0,
    x2: 21.445,
    y2: 59.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C0583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732BD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_754_4086",
    x1: 21.445,
    y1: 5.95752,
    x2: 21.445,
    y2: 52.4221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C0583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732BD1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_754_4086"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.95691,
    y: 5.95752,
    width: 30.9761,
    height: 46.4646,
    rx: 0.997015,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMystic);
export default __webpack_public_path__ + "static/media/mystic.4f1ad7a952bc70f45fb6bad2dde903cc.svg";
export { ForwardRef as ReactComponent };